<footer class="hr">
   <span class="text-muted">© {{year}} All rights reserved | <span class="primary-color">Heemkringscheldeveld</span></span>
</footer>